import {Component, OnInit, OnDestroy} from '@angular/core';
import {Router, ActivatedRoute, NavigationStart} from '@angular/router';
import {formatDate, Location} from '@angular/common';

import {CDSNode, Org, OrgSettings} from '../services/capd.model';
import { OrgService } from '../services/org.service';
import {ExportToCsv} from "export-to-csv";
import * as $ from "jquery";
import {AlertService} from "../services/alert.service";
import {v4 as uuidv4} from 'uuid';
import * as moment from 'moment';
import {Subscription} from "rxjs";

@Component({
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.less'],
  providers: [OrgService, Location]
})

/**
 * Component for the org/company settings page.
 */
export class SettingsComponent implements OnInit, OnDestroy {
  exportSettings = []
  orgName = '';
  showAdvanced = false;
  advText: string;
  org: Org = {
    _id: '',
    settings: { }
  };
  initOrgVals: Org = {
    _id: '',
    settings: { }
  };
  root: string;
  expandedRoot: string;
  scope: string;
  private sub: any;
  advArray = {
    nlpSessionParameters :  [],
    hulkSessionParameters : [],
    capdServicesSessionParameters : [],
    nlpRequestParameters :  [],
    hulkRequestParameters : [],
    capdServicesRequestParameters : [],
    hccSettings: [],
    cdiCollaborateSettings: [],
    modified: []
  };
  initAdvArray = {
    nlpSessionParameters :  [],
    hulkSessionParameters : [],
    capdServicesSessionParameters : [],
    nlpRequestParameters :  [],
    hulkRequestParameters : [],
    capdServicesRequestParameters : [],
    hccSettings: [],
    cdiCollaborateSettings: [],
    modified: []
  };
  advArrayCopy = null;
  advArrayNameMapping = {
    nlpSessionParameters :  'NLP Session Parameters',
    hulkSessionParameters : 'Hulk Session Parameters',
    capdServicesSessionParameters : 'CAPD Services Session Parameters',
    nlpRequestParameters :  'NLP Request Parameters',
    hulkRequestParameters : 'Hulk Request Parameters',
    capdServicesRequestParameters : 'CAPD Services Request Parameters',
    hccSettings: 'HCC Settings',
    cdiCollaborateSettings: 'CDI Collaborate Settings',
    modified: ''
  }

  settingsUnchanged: boolean = false
  settingsHaveDupes = false;
  routerSubscription: Subscription;
  duplicateSettingMessage = "Another setting is using this name. Please ensure you’ve entered the name correctly.";
  isNewSettingDuplicate = false;
  version: string;

  constructor(private _service: OrgService,
              private _router: Router,
              private _route: ActivatedRoute,
              private alertService: AlertService) {
  }

  /**
   * Get the current org settings object and, if anything is unset, add default values.
   *
   * @async
   * @func ngOnInit
   */
  ngOnInit() {
    this.scope = sessionStorage.getItem('scope');
    this.showAdvanced = false;
    this.sub = this._route.params.subscribe(params => {
      this.root = params.id;
      this.expandedRoot = this.root.replace('~', '2.16.840.1.113883.3.21');
      this.version = sessionStorage.getItem('uiVersion');

      this._service.getOrg(this.root).then((pak: CDSNode) => {
        // add if to prevent undefined error
        if(pak)
          this.orgName = pak.description
      });
      if(this.version == 'Classic') {
        this._service.getOrgSettings(this.root).then(org => {
          // @ts-ignore
          this.org = org;

          if (!this.org.settings.pipelineId) {
            this.org.settings.pipelineId = '';
          }
          if (!this.org.settings.maxCacheDocumentPerContext) {
            this.org.settings.maxCacheDocumentPerContext = 2;
          }
          if (this.org.settings.showMessageBalloon === undefined || this.org.settings.showMessageBalloon === null) {
            this.org.settings.showMessageBalloon = true;
          }
          if (this.org.settings.engageAnalyticsEnabled === undefined || this.org.settings.engageAnalyticsEnabled === null) {
            this.org.settings.engageAnalyticsEnabled = false;
          }
          if (this.org.settings.capdForFfiEnabled === undefined || this.org.settings.capdForFfiEnabled === null) {
            this.org.settings.capdForFfiEnabled = false;
          }
          if (!this.org.settings.mmodalNotes) {
            this.org.settings.mmodalNotes = '';
          }
          /*
          if (this.org.settings.hccEnabled === undefined || this.org.settings.showMessageBalloon === null) {
            this.org.settings.hccEnabled = false;
          }
          if (!this.org.settings.hccEndpoint) {
            this.org.settings.hccEndpoint = '';
          }
          */
          if ('settings' in org) {
            this.initParams(org.settings);
          }

          // @ts-ignore
          this.initOrgVals = JSON.parse(JSON.stringify(this.org));
        })
            .catch(err => {
              if (this.org === null) {
                // setting does not exist yet, so we're creating a new one.
                this.org = ({settings: {}} as Org);
              }
              this.org._id = this.root;
              this.org.settings.maxCacheDocumentPerContext = 2;
              this.org.settings.mmodalNotes = '';
              this.org.settings.tenantMapping = '';
              this.org.settings.hccUrlBase = '';
              this.showAdvanced = false;
              this.advArray = {
                nlpSessionParameters: [],
                hulkSessionParameters: [],
                capdServicesSessionParameters: [],
                nlpRequestParameters: [],
                hulkRequestParameters: [],
                capdServicesRequestParameters: [],
                hccSettings: [],
                cdiCollaborateSettings: [],
                modified: []
              };
              // use the JSON parse and stringify to ensure we are getting a new object rather than a pointer to the old
              this.initAdvArray = JSON.parse(JSON.stringify(this.advArray));
              this.initOrgVals = JSON.parse(JSON.stringify(this.org));
            });
      } else (
          this._service.getOrgSettingsV2(this.root).then(org => {

            // @ts-ignore
            this.org = org;

            if (!this.org.settings.pipelineId) {
              this.org.settings.pipelineId = '';
            }
            if (!this.org.settings.maxCacheDocumentPerContext) {
              this.org.settings.maxCacheDocumentPerContext = 2;
            }
            if (this.org.settings.showMessageBalloon === undefined || this.org.settings.showMessageBalloon === null) {
              this.org.settings.showMessageBalloon = true;
            }
            if (this.org.settings.engageAnalyticsEnabled === undefined || this.org.settings.engageAnalyticsEnabled === null) {
              this.org.settings.engageAnalyticsEnabled = false;
            }
            if (this.org.settings.capdForFfiEnabled === undefined || this.org.settings.capdForFfiEnabled === null) {
              this.org.settings.capdForFfiEnabled = false;
            }
            if (!this.org.settings.mmodalNotes) {
              this.org.settings.mmodalNotes = '';
            }
            /*
            if (this.org.settings.hccEnabled === undefined || this.org.settings.showMessageBalloon === null) {
              this.org.settings.hccEnabled = false;
            }
            if (!this.org.settings.hccEndpoint) {
              this.org.settings.hccEndpoint = '';
            }
            */
            if ('settings' in org) {
              this.initParams(org.settings);
            }

            // @ts-ignore
            this.initOrgVals = JSON.parse(JSON.stringify(this.org));
          })
      ).catch(err => {
        if (this.org === null) {
          // setting does not exist yet, so we're creating a new one.
          this.org = ({settings: {}} as Org);
        }
        this.org._id = this.root;
        this.org.settings.maxCacheDocumentPerContext = 2;
        this.org.settings.mmodalNotes = '';
        this.org.settings.tenantMapping = '';
        this.org.settings.hccUrlBase = '';
        this.showAdvanced = false;
        this.advArray = {
          nlpSessionParameters: [],
          hulkSessionParameters: [],
          capdServicesSessionParameters: [],
          nlpRequestParameters: [],
          hulkRequestParameters: [],
          capdServicesRequestParameters: [],
          hccSettings: [],
          cdiCollaborateSettings: [],
          modified: []
        };
        // use the JSON parse and stringify to ensure we are getting a new object rather than a pointer to the old
        this.initAdvArray = JSON.parse(JSON.stringify(this.advArray));
        this.initOrgVals = JSON.parse(JSON.stringify(this.org));
      });
    });

    this.routerSubscription = this._router.events.subscribe((event: any) => {
      if(!this.settingsUnchanged && event.url !== this._router.routerState.snapshot.url && event instanceof NavigationStart) {
        if(confirm("You are about to leave the page without saving; all unsaved changes will be lost. Would you like to proceed and abandon current changes?")){
          // continue nav by setting settingsUnchanged to true
          this.settingsUnchanged = true
        }
        else{
          // do not leave current page
          this._router.navigateByUrl(this._router.routerState.snapshot.url)
        }
      }

    });
  }

  /**
   * If the user has any orgSettings, initialize them here.
   *
   * @func initParams
   * @param {OrgSettings} org - the org object to parse.
   */
  initParams(org: OrgSettings) {
    for (const param in this.advArray) {
      if(param != "modified") {
        if (this.advArray.hasOwnProperty(param) && org.hasOwnProperty(param)) {
          this.advArray[param] = [];
          for (const settingName in org[param]) {
            if (org[param].hasOwnProperty(settingName)) {
              const escapedKey = settingName.replace(/\\\\u0024/g, '$').replace(/\\\\u002e/g, '.').replace(/\\\\u005c/g, '\\');
              const escapedValue = org[param][settingName].replace(/\\\\u005c/g, '\\');
              this.advArray[param].push({
                key: escapedKey,
                value: escapedValue,
                originalKey: escapedKey,
                originalValue: escapedValue,
                uuid: uuidv4()
              });
            }
          }
          this.initAdvArray = JSON.parse(JSON.stringify(this.advArray))
        } else {
          this.advArray[param] = [{key: '', value: ''}];
          this.initAdvArray = JSON.parse(JSON.stringify(this.advArray))
        }
      }
    }
  }

  /**
   * Get the keys of an array of objects
   *
   * @func getObjectKeys
   */
  getObjectKeys(obj: any): string[] {
    return Object.keys(obj);
  }

  /**
   * Simple toggle between entering a trigger code and entering a SQL query.
   *
   * @func toggleAdvanced
   */
  toggleAdvanced() {
    this.showAdvanced = !this.showAdvanced;
    if (this.showAdvanced) { this.advText = 'Hide advanced'; }
    else { this.advText = 'Show advanced'; }
  }

  /**
   * Sets the message balloon.
   *
   * @func setMsgBalloon
   * @param {boolean} value - the value to set the message balloon to.
   */
  setMsgBalloon(value: boolean) {
    this.org.settings.showMessageBalloon = value;
  }

  setEngageAnalyticsEnabled(value: boolean) {
      this.org.settings.engageAnalyticsEnabled = value;
  }

  /**
   * Adds a new setting to one of the advanced settings arrays.
   *
   * @func addSetting
   * @param {string} key - the advanced settings array key.
   */
  addEmptySetting(key) {
    const newSetting = {key: '', value: ''};
    if (this.advArray.hasOwnProperty(key)) {
      this.advArray[key].push(newSetting);
    }
  }

  /**
   * Adds a new setting to one of the advanced settings arrays.
   *
   * @func addSetting
   * @param {string} settingGroupKey - the advanced settings array key.
   * @param {form} newSettingForm - the form of inputs that define the setting
   */
  addSetting(settingGroupKey: string, newSettingForm) {
    // gather the form values
    let newSettingKey = newSettingForm.value.new_setting_key;
    let newSettingValue = newSettingForm.value.new_setting_value;
    let newSettingTargetApplication = newSettingForm.value.new_setting_target;

    // ensure there are values.  Should never hit this because button is disabled without values
    if(!newSettingKey || ! newSettingValue) {
      this.alertService.showAlert("Name and value are required");
      return;
    }
    newSettingKey = newSettingKey.trim();
    newSettingValue = newSettingValue.trim();

    // replace target application
    if(newSettingTargetApplication) {
      newSettingKey = newSettingKey.replace("<targetApplication>", newSettingTargetApplication).replace("<targetapplication>", newSettingTargetApplication);
    } else {
      newSettingKey = newSettingKey.replace("<targetApplication>", "").replace("<targetapplication>", "");
    }

    // look for duplicates
    let hasDupes = false;
    this.isNewSettingDuplicate = false;
    this.advArray[settingGroupKey].forEach(setting => {
      if (setting.key.trim() === newSettingKey) {
        setting.isDuplicate = true;
        this.isNewSettingDuplicate = true;
        hasDupes = true;
      }
    });

    // add the new setting
    if (!hasDupes) {
      const newSetting = {key: newSettingKey, value: newSettingValue, status: 'new'};
      if (this.advArray.hasOwnProperty(settingGroupKey)) {
        this.advArray[settingGroupKey].push(newSetting);
        this.doSettingsHaveDuplicates();
        this.onSave();
      }
    }
  }

  /**
   *  Marks a setting as changed
   *
   * @async
   * @func markChanged
   */
  markUpdated(setting: any) {
    if (setting.originalKey === setting.key && setting.originalValue === setting.value) {
      setting.status = null;
    } else {
      setting.status = 'updated';
    }
  }

  /**
   * Reverts a setting to its original key/value.
   *
   * @async
   * @func revertSetting
   */
  revertSetting(setting: any) {
    if (setting.originalKey) {
      setting.key = setting.originalKey;
    }
    if (setting.originalValue) {
      setting.value = setting.originalValue;
    }
    setting.status = null;
    this.doSettingsHaveDuplicates();
  }

  /**
   * Removes a setting from a given array.
   *
   * @func removeSetting
   * @param {string} key - the advanced settings array key.
   * @param {number} setting - the index of the setting to remove.
   */
  removeSetting(key, setting) {
    if (this.advArray.hasOwnProperty(key)) {
      this.advArray[key].splice(this.advArray[key].indexOf(setting), 1);
    }
  }

  /**
   * Mark a setting to be deleted.
   *
   * @func markSettingDeleted
   * @param {number} setting - the index of the setting to mark.
   */
  markSettingDeleted(setting) {
    setting.status = 'deleted';
  }

  /**
   * Remove mark for deletion from a setting.
   *
   * @func undoMarkSettingDeleted
   * @param {number} setting - the index of the setting to mark.
   */
  undoMarkSettingDeleted(setting) {
    setting.status = null;
  }

  moveSettingUp(key, setting) {
    var moveUp: number = this.advArray[key].indexOf(setting);
    var moveDown: number = moveUp - 1;
    [this.advArray[key][moveUp], this.advArray[key][moveDown]] = [this.advArray[key][moveDown], this.advArray[key][moveUp]];
  }

  moveSettingDown(key, setting) {
    var moveUp: number = this.advArray[key].indexOf(setting);
    var moveDown: number = moveUp + 1;
    [this.advArray[key][moveUp], this.advArray[key][moveDown]] = [this.advArray[key][moveDown], this.advArray[key][moveUp]];
  }

  /**
   * Saves the settings to the server.
   *
   * @async
   * @func onSave
   */
  onSave() {
    if (!!this.org.settings.pipelineId && this.org.settings.pipelineId.length < 1) {
      this.org.settings.pipelineId = undefined;
    }
    if (!!this.org.settings.maxCacheDocumentPerContext && this.org.settings.maxCacheDocumentPerContext === 2) {
      this.org.settings.maxCacheDocumentPerContext = undefined;
    }

    for (const param in this.advArray) {
      if(param != "modified") {
        this.org.settings[param] = {};
        if (this.advArray.hasOwnProperty(param) && this.advArray[param].length > 0) {
          
          this.advArray[param] = this.advArray[param].filter(s => {
            return s.status !== 'deleted';
          });
          this.advArray[param].forEach((setting, index) => {
            if (setting.key.trim().length > 0 && setting.value.trim().length > 0) {
              const escKey = String(setting.key).replace(/\\/g, '\\\\u005c').replace(/\$/g, '\\\\u0024').replace(/\./g, '\\\\u002e').trim();
              this.org.settings[param][escKey] = String(setting.value).replace(/\\/g, '\\\\u005c');
            }
            setting.status = null;
            setting.isDuplicate = false;

            if ((this.initAdvArray[param][index] == undefined) || ((this.initAdvArray[param][index].key !== setting.key) || (this.initAdvArray[param][index].value !== setting.value))) {
              if (this.org.settings.modified == undefined) {
                this.org.settings.modified = [];
              }

              // clear out old modification records
              let initSetting = this.initAdvArray[param][index];
              let filteredModifications = this.org.settings.modified.filter(mod => {
                const isMatchingSetting = mod.setting.key === setting.key && mod.settingGroup === param;
                const isMatchingInitSetting = initSetting && mod.setting.key === initSetting.key && mod.settingGroup === param;
                if (isMatchingSetting || isMatchingInitSetting) {
                  return false;
                }
                return true;
              });

              let modification = {
                'setting': setting,
                'modified': new Date(),
                'settingGroup' : param,
                'modifiedBy': sessionStorage.getItem('username')
              }
              filteredModifications.push(modification);
              this.org.settings.modified = filteredModifications;
            }
          });
        }
      }
    }

    if (this.version == 'Classic') {
      this._service.updateOrg(this.org, this.root).then(() => {
        //wrap in the JSON.parse and JSON.stringify so that we assign only a value, not a reference
        this.initOrgVals.settings = JSON.parse(JSON.stringify(this.org.settings));
        this.initAdvArray = JSON.parse(JSON.stringify(this.advArray));
        this.initParams(this.org.settings);
      });
    } else {
      this._service.updateOrgSettingsV2(this.org, this.root).then(() => {
        //wrap in the JSON.parse and JSON.stringify so that we assign only a value, not a reference
        this.initOrgVals.settings = JSON.parse(JSON.stringify(this.org.settings));
        this.initAdvArray = JSON.parse(JSON.stringify(this.advArray));
      });
    }

  }

  isModified(setting: any) {
    if (this.org.settings.modified != undefined) {
      let mod = this.org.settings.modified.filter(x =>
          (x.settingGroup) &&
          (x.setting.key == setting.key) &&
          (x.setting.value == setting.value) &&
          (x.setting.settingGroup === setting.settingGroup)
      );
      if (mod != undefined && mod.length > 0) {
        let foundMod = mod[0];
        if (moment(foundMod.modified).isValid()) {
          return formatDate(foundMod.modified, 'MM/dd/yyyy', 'en') + " by " + foundMod.modifiedBy;
        } else {
          return foundMod.modified;
        }
      } else {
        return "";
      }
    }
    else {
      return "";
    }
  }

  doSettingsHaveDuplicates(): boolean {

    this.settingsHaveDupes = false;
    for (const param in this.advArray) {
      if (this.advArray.hasOwnProperty(param) && this.advArray[param].length > 0) {
        if (this.doesSettingHaveDuplicates(this.advArray[param], param)) {
          this.settingsHaveDupes = true;
        }
      }
    }
    return this.settingsHaveDupes;
  }

  /**
   * Checks to see if settings contain duplicate key names
   *
   * @func doSettingsHaveDuplicates
   * @returns true if the settings do have duplicate key names; otherwise false.
   */
  doesSettingHaveDuplicates(settings, section): boolean {
    let res = {};
    let hasDupes = false;
    settings.forEach(function(setting) {
      if (!res.hasOwnProperty(setting.key.toLowerCase())) {
        res[setting.key.toLowerCase()] = setting.value;
        setting.isDuplicate = false;
      } else {
        hasDupes = true;
        settings.forEach(set => {
          if (set.key === setting.key) {
            set.isDuplicate = true;
          }
        });
      }
    });
    return hasDupes;
  }

  /**
   * Checks to see if settings have been change from original state
   *
   * @func isUnchanged
   * @returns true if the settings have NOT been changed; false otherwise.
   */
  isUnchanged() {
    // can use just .settings for pipeline id, mmodal notes, and tenant mapping.
    // need something else to take care of advanced settings

    // make a copy of advArray and strip out metadata that falsely enables Save button
    this.advArrayCopy = JSON.parse(JSON.stringify(this.advArray));
    this.advArrayCopy = this.stripMetaDataFromAdvArray(this.advArrayCopy);
    this.initAdvArray = this.stripMetaDataFromAdvArray(this.initAdvArray);

    this.settingsUnchanged = (JSON.stringify(this.org.settings) === JSON.stringify(this.initOrgVals.settings)) &&
        (this.areEqualJSON(this.advArrayCopy, this.initAdvArray));
    return this.settingsUnchanged
  }

  /**
   * Checks to see if any of the new settings inputs have values
   *
   * @func newSettingFormHasValues
   * @returns true if any of the new settings inputs have values.
   */
  newSettingFormHasValues() {
    const new_setting_keys = $('input[name="new_setting_key"]');
    const keys_have_values = new_setting_keys.toArray().some((input) => $(input).val() !== '');

    const new_setting_values = $('input[name="new_setting_value"]');
    const values_have_values = new_setting_values.toArray().some((input) => $(input).val() !== '');

    const new_setting_targets = $('input[name="new_setting_target"]');
    const targets_have_values = new_setting_targets.toArray().some((input) => $(input).val() !== '');

    if (keys_have_values || values_have_values || targets_have_values) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * Does a deep sort and comparison of two complex objects.  Ignores the order of the items within each object
   *
   * @func areEqualJSON
   * @param {any} obj1 - a complex object.
   * @param {any} obj2 - a complex object.
   * @returns true if the two objects are equal.
   */
  areEqualJSON(obj1: any, obj2: any): boolean {
    const sortDeep = (obj: any) => {
      if (Array.isArray(obj)) {
        return obj.map((item: any) => sortDeep(item)).sort();
      } else if (typeof obj === 'object' && obj !== null) {
        return Object.keys(obj)
            .sort()
            .reduce((acc: any, key: string) => {
              acc[key] = sortDeep(obj[key]);
              return acc;
              }, {} as { [key: string]: any
            });
          }
          return obj;
        };
    const sortedObj1 = sortDeep(obj1);
    const sortedObj2 = sortDeep(obj2);
    return JSON.stringify(sortedObj1) === JSON.stringify(sortedObj2);
  }

  /**
   * Strips out metadata from the advanced setting array to facilitate proper comparison
   *
   * @func stripMetaDataFromAdvArray
   * @param {any} advArray - the advanced settings array.
   * @returns the array with metadata stripped out for isUnchanged comparison.
   */
  stripMetaDataFromAdvArray(advArray: any) {
    // strip key whitespace so save button is not enabled unnecessarily
    const clonedAdvArray = JSON.parse(JSON.stringify(advArray));
    for (const param in clonedAdvArray) {
      if (clonedAdvArray.hasOwnProperty(param) && advArray[param].length > 0) {
        clonedAdvArray[param].forEach(setting => {
          setting = this.stripSettingMetaData(setting, false);
        });
      }
    }
    return clonedAdvArray;
  }

  stripSettingMetaData(setting: any, stripDeleted: boolean):any {
    setting.key = setting.key.trim();
    setting.isDuplicate = null;
    setting.originalKey = null;
    setting.originalValue = null;
    setting.uuid = null;
    if (setting.status !== 'deleted' || stripDeleted) {
      setting.status = null;
    }
    return setting;
  }

  /**
   * Disposes of the subscriber object.
   *
   * @async
   * @func ngOnDestroy
   */
  ngOnDestroy() {
    this.sub.unsubscribe();
    this.routerSubscription.unsubscribe();
  }

  createSettingsCSV() {

    this.exportSettings = []

    // for single value settings
    const paramValueOID = {
      'Setting Type': 'CDS Account OID',
      'Setting Name': '',
      'Setting Value': this.expandedRoot
    }
    this.exportSettings.push(paramValueOID)

    const paramValuePipeline = {
      'Setting Type': 'Pipeline ID',
      'Setting Name': '',
      'Setting Value': this.org.settings.pipelineId
    }
    this.exportSettings.push(paramValuePipeline)

    const paramValueMapping = {
      'Setting Type': 'Tenant Mapping',
      'Setting Name': '',
      'Setting Value': this.org.settings.tenantMapping
    }
    this.exportSettings.push(paramValueMapping)

    const paramValueNotes = {
      'Setting Type': 'M*Modal Notes',
      'Setting Name': '',
      'Setting Value': this.org.settings.mmodalNotes
    }
    this.exportSettings.push(paramValueNotes)

    // one for each setting type
    this.advArray.nlpSessionParameters.forEach(param => {
      const paramValue = {
        'Setting Type': 'NLP Session Parameter',
        'Setting Name': param.key,
        'Setting Value': param.value,
      }
      this.exportSettings.push(paramValue)
    })

    this.advArray.hulkSessionParameters.forEach(param => {
      const paramValue = {
        'Setting Type': 'Hulk Session Parameter',
        'Setting Name': param.key,
        'Setting Value': param.value,
      }
      this.exportSettings.push(paramValue)
    })

    this.advArray.capdServicesSessionParameters.forEach(param => {
      const paramValue = {
        'Setting Type': 'CAPD Services Session Parameter',
        'Setting Name': param.key,
        'Setting Value': param.value,
      }
      this.exportSettings.push(paramValue)
    })

    this.advArray.nlpRequestParameters.forEach(param => {
      const paramValue = {
        'Setting Type': 'NLP Request Parameter',
        'Setting Name': param.key,
        'Setting Value': param.value,
      }
      this.exportSettings.push(paramValue)
    })

    this.advArray.hulkRequestParameters.forEach(param => {
      const paramValue = {
        'Setting Type': 'Hulk Request Parameter',
        'Setting Name': param.key,
        'Setting Value': param.value,
      }
      this.exportSettings.push(paramValue)
    })

    this.advArray.capdServicesRequestParameters.forEach(param => {
      const paramValue = {
        'Setting Type': 'CAPD Services Request Parameter',
        'Setting Name': param.key,
        'Setting Value': param.value,
      }
      this.exportSettings.push(paramValue)
    })

    this.advArray.hccSettings.forEach(param => {
      const paramValue = {
        'Setting Type': 'HCC Setting',
        'Setting Name': param.key,
        'Setting Value': param.value,
      }
      this.exportSettings.push(paramValue)
    })

    this.advArray.cdiCollaborateSettings.forEach(param => {
      const paramValue = {
        'Setting Type': 'CDI Collaborate Setting',
        'Setting Name': param.key,
        'Setting Value': param.value,
      }
      this.exportSettings.push(paramValue)
    })

    //these are for the checkbox values for engagea analytics and ffi
    const paramValueEngage = {
      'Setting Type': 'Engage Analytics Enabled',
      'Setting Name': '',
      'Setting Value': this.org.settings.engageAnalyticsEnabled
    }
    this.exportSettings.push(paramValueEngage)

    const paramValueFFI = {
      'Setting Type': 'CAPD for FFI Enabled',
      'Setting Name': '',
      'Setting Value': this.org.settings.capdForFfiEnabled
    }
    this.exportSettings.push(paramValueFFI)

  }
  async exportSettingsCSV() {
    await this.createSettingsCSV();

    const options = {
      filename: this.orgName + '_settings_export_' + Date.now(),
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      showTitle: true,
      title: this.orgName + '_settings_export_' + Date.now(),
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true
    };

    const csvExporter = new ExportToCsv(options);
    csvExporter.generateCsv(this.exportSettings)
  }

}
